/**
 * groupAssignmentModule
 * author zhang.yingyu
 * createTime 2019-03-21
 *
 * modify Qian.qianchen
 * modifyTime 2019-07-12
 **/
"use strict";
angular.module('groupAssignmentModule', ['commandMoudle', 'groupAssignmentServiceModule']).controller('groupAssignmentCtrl', ["$scope", "$state", "$validation", "trsHttpService", "trsspliceString", "modalDialog", "$filter", "planningCenterService", "groupAssignmentService", "$stateParams", "$q",
    function($scope, $state, $validation, trsHttpService, trsspliceString, modalDialog, $filter, planningCenterService, groupAssignmentService, $stateParams, $q) {
        initStatus();
        initData();
        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                assignmentId: angular.isDefined($stateParams.taskid) ? $stateParams.taskid : 0,
                reportId: angular.isDefined($stateParams.reportid) ? $stateParams.reportid : 0,
            }
            $scope.data = {
                executorArr: [],
            }
        }
        /**
         * [initData description] 数据初始化
         * @return {[type]} [description]
         */
        function initData() {
            if ($scope.status.assignmentId != 0) {
                initEditData();
            } else {
                initNewData();
            }
        }
        /**
         * [initNeData description] 新建数据初始化
         * @return {[type]} [description]
         */
        function initNewData() {
            $scope.list = groupAssignmentService.initAssignmentData();
        }
        /**
         * [initEditData description] 编辑数据初始化
         * @return {[type]} [description]
         */
        function initEditData() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_taskcommand',
                methodname: 'getTaskDetail',
                TaskId: $scope.status.assignmentId
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "GET").then(function(data) {
                $scope.list = {
                    "TaskCommandId": $scope.status.assignmentId,
                    "TaskName": data.TASKNAME,
                    "TaskTime": data.TASKTIME,
                    "TaskAddress": data.TASKADDRESS,
                    "Content": data.CONTENT,
                    "UserIds": data.USERIDS,
                    "Remarks": data.REMARKS,
                    "Address": data.ADDRESS,
                    "IsMine": 0
                };
                let userIdArr = data.USERIDS.split(',');
                let userNameArr = data.USERNAMES.split(',');
                $scope.data.myStatus = data.MYSTATUS;
                $scope.data.executorArr = userIdArr.map(function(item, index) {
                    return {
                        USERNAME: userNameArr[index],
                        ID: item
                    }
                });
                defer.resolve();
            });
            return defer.promise;
        }
        /**
         * [setLocation description] 地图定位
         */
        $scope.setLocation = function() {
            planningCenterService.setLocation($scope.list.TaskAddress).then(function(address) {
                $scope.list.TaskAddress = address;
            });
        }
        /**
         * [addExecutor description] 添加执行人
         */
        $scope.addExecutor = function() {
            $scope.editorJson = $scope.data.executorArr;
            groupAssignmentService.addExecutor($scope).then(function(result) {
                $scope.data.executorArr = result.map(function(item) {
                    return {
                        ID: item.ID,
                        USERNAME: item.USERNAME
                    }
                });
            });
        }
        /**
         * [deleteItem description] 删除执行人
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.deleteItem = function(item) {
            $scope.data.executorArr.splice($scope.data.executorArr.indexOf(item), 1);
        }
        /**
         * [confirm description] 审核并发布
         * @return {[type]} [description]
         */
        $scope.confirm = function(flag) {
            var defer = $q.defer();
            flag = angular.isDefined(flag) ? flag : true;
            $scope.assignmentForm.$pending = {};
            $validation.validate($scope.assignmentForm)
                .success(function() {
                    var list = angular.copy($scope.list);
                    list.UserIds = trsspliceString.spliceString($scope.data.executorArr, 'ID', ',');
                    list.serviceid = 'mlf_taskcommand';
                    list.methodname = 'saveTaskCommand';
                    list.TaskTime = $filter("date")(list.TaskTime, "yyyy-MM-dd HH:mm:ss");
                    list.TaskAddress = list.TaskAddress == "" ? "" : JSON.stringify(list.TaskAddress);
                    list.ReportId = $scope.status.reportId;
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, "POST").then(function(data) {
                        if (flag) {
                            modalDialog.alertType($scope.status.assignmentId != 0 ? '编辑成功' : '创建成功', '', 'success', false, function() {
                                history.go(-1);
                            });
                        }
                        $scope.status.assignmentId = data.TASKCOMMANDID;
                        defer.resolve();
                    });
                });
            return defer.promise;
        }
        /**
         * [goBack description] 返回
         * @return {[type]} [description]
         */
        $scope.goBack = function() {
            history.go(-1);
        }
    }
]);